webpackJsonp([60],{

/***/ 1080:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1081);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(491)("657f97d2", content, true);

/***/ }),

/***/ 1081:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(490)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.center-buttons{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}", "", {"version":3,"sources":["/opt/buildhome/repo/src/pages/configuration/page-dealers-resource.vue"],"names":[],"mappings":"AACA,WACE,yBAA4B,AAC5B,0CAA2C,AAC3C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,sBAAyB,AACzB,uCAAwC,AACxC,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,uBAA0B,AAC1B,wCAAyC,AACzC,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,0BAA6B,AAC7B,8CAA+C,AAC/C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,uBAA0B,AAC1B,2CAA4C,AAC5C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,+CAAgD,AAChD,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,wBAA2B,AAC3B,4CAA6C,AAC7C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,gBACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACjC","file":"page-dealers-resource.vue","sourcesContent":["\n@font-face {\n  font-family: 'Lato_regular';\n  src: url(\"/static/fonts/Lato-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Lato_bold';\n  src: url(\"/static/fonts/Lato-Bold.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Lato_light';\n  src: url(\"/static/fonts/Lato-Light.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_regular';\n  src: url(\"/static/fonts/OpenSans-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_bold';\n  src: url(\"/static/fonts/OpenSans-Bold.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_semibold';\n  src: url(\"/static/fonts/OpenSans-SemiBold.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_light';\n  src: url(\"/static/fonts/OpenSans-Light.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n.center-buttons {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1082:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dealers-resource"},[_c('action-sidebar',{attrs:{"title":"Recursos","value":true,"width":644},on:{"close-modal":_vm.closeModal}},[_c('v-tabs',{attrs:{"right":"","slider-color":"cyan"},model:{value:(_vm.tabsResource),callback:function ($$v) {_vm.tabsResource=$$v},expression:"tabsResource"}},[_vm._l((_vm.tabs),function(item,index){return _c('v-tab',{key:index},[_vm._v("\n\t\t\t\t"+_vm._s(item.name)+"\n\t\t\t")])}),_vm._v(" "),_c('v-tabs-items',[_c('v-tab-item',[_c('v-flex',{attrs:{"xs9":"","text-xs-left":""}},[_c('v-select',{staticClass:"body-1 mt-4 px-3",attrs:{"items":_vm.listApplications,"background-color":"white","box":"","hide-details":"","item-text":"name","item-value":"id","label":"Aplicaciones"},on:{"change":function($event){_vm.loadResource(1)}},model:{value:(_vm.appId),callback:function ($$v) {_vm.appId=$$v},expression:"appId"}})],1),_vm._v(" "),_c('app-table',{staticClass:"mt-5 is-not-selectable px-3",attrs:{"selectable":"","name":"resource","selected-value":_vm.selectedValue,"check-all":_vm.checkAll,"columns":_vm.columns,"rows":_vm.listResource,"current-page":_vm.currentPage,"last-page":_vm.lastPage,"inputSearch":false,"filterColumns":false},on:{"on-page":_vm.loadResource,"row-is-selected":_vm.rowIsSelected,"on-selected-all":_vm.allSelected},scopedSlots:_vm._u([{key:"rows",fn:function(props){return [_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 1)),expression:"showRow(columns, 1)"}],staticClass:"is-not-selectable"},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(props.row.uri)+"\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 2)),expression:"showRow(columns, 2)"}]},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(props.row.description)+"\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.showRow(_vm.columns, 3)),expression:"showRow(columns, 3)"}]},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(props.row.module ? props.row.module.data && props.row.module.data.name : '')+"\n\t\t\t\t\t\t\t\t")])]}}])})],1),_vm._v(" "),_c('v-tab-item',[_c('v-flex',{attrs:{"xs9":"","ml-3":""}},[_c('v-select',{staticClass:"body-1 mt-4 px-2",attrs:{"background-color":"white","box":"","hide-details":"","items":_vm.listApplications,"item-text":"name","item-value":"id","label":"Aplicaciones"},model:{value:(_vm.appIdAssigned),callback:function ($$v) {_vm.appIdAssigned=$$v},expression:"appIdAssigned"}})],1),_vm._v(" "),_c('app-table',{staticClass:"mt-5 is-not-selectable px-3",attrs:{"name":"resource","selected-value":_vm.selectedValueAssigned,"columns":_vm.columns,"check-all":_vm.checkAllAssigned,"rows":_vm.listResourceAssigned,"current-page":_vm.currentPageAssigned,"last-page":_vm.lastPageAssigned,"inputSearch":false,"filterColumns":false,"selectable":""},on:{"on-page":_vm.loadResourceAssigned,"row-is-selected":_vm.rowIsSelectedDeallocated,"on-selected-all":_vm.allSelectedAssigned},scopedSlots:_vm._u([{key:"rows",fn:function(props){return [_c('td',{directives:[{name:"show",rawName:"v-show",value:((_vm.columns, 1)),expression:"(columns, 1)"}],staticClass:"is-not-selectable"},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(props.row.uri)+"\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:((_vm.columns, 2)),expression:"(columns, 2)"}]},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(props.row.description)+"\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:((_vm.columns, 3)),expression:"(columns, 3)"}]},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(props.row.module ? props.row.module.data && props.row.module.data.name : '')+"\n\t\t\t\t\t\t\t\t")])]}}])})],1)],1)],2),_vm._v(" "),_c('section',{staticClass:"modal-filter-footer pt-4 pb-4 center-buttons"},[_c('v-btn',{staticClass:"btn-action caption ml-2",attrs:{"color":"pink"},on:{"click":_vm.closeModal}},[_vm._v("\n\t\t\t\t\tCancelar\n\t\t\t\t")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-action caption ml-2",attrs:{"color":"success","disabled":_vm.disabledAssigned(1)},on:{"click":_vm.assignedResource}},[_vm._v("\n\t\t\t\tAsignar\n\t\t\t\t")]),_vm._v(" "),_c('v-btn',{staticClass:"btn-action caption ml-2",attrs:{"color":"success","disabled":_vm.disabledDeallocate(0)},on:{"click":_vm.deallocateResource}},[_vm._v("\n\t\t\t\tDesasignar\n\t\t\t\t")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 526:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_dealers_resource_vue__ = __webpack_require__(855);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b45b385_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_dealers_resource_vue__ = __webpack_require__(1082);
function injectStyle (ssrContext) {
  __webpack_require__(1080)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_dealers_resource_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b45b385_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_dealers_resource_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 855:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_action_sidebar__ = __webpack_require__(149);




var loadApplications = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
		var params, response;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						params = {
							page: 1,
							perPage: 30,
							isSelected: 1
						};
						_context.prev = 1;
						_context.next = 4;
						return this.$http.get('distributaries/' + this.id + '/apps', { params: params });

					case 4:
						response = _context.sent;

						this.listApplications = response.data.data;
						_context.next = 11;
						break;

					case 8:
						_context.prev = 8;
						_context.t0 = _context['catch'](1);

						if (_context.t0.status === 500) {
							this.showError();
						}

					case 11:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[1, 8]]);
	}));

	return function loadApplications() {
		return _ref.apply(this, arguments);
	};
}();

var loadResource = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
		var params, response;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						this.currentPage = page;
						this.params.page = this.currentPage;
						params = {
							isSelected: 0,
							page: this.params.page,
							perPage: 30,
							appId: this.appId
						};
						_context2.prev = 3;
						_context2.next = 6;
						return this.$http.get('distributaries/' + this.id + '/resources', { params: params });

					case 6:
						response = _context2.sent;

						this.listResource = response.data.data;
						this.lastPage = Number(response.headers['x-last-page']);
						_context2.next = 14;
						break;

					case 11:
						_context2.prev = 11;
						_context2.t0 = _context2['catch'](3);

						if (_context2.t0.status === 500) {
							this.showError();
						}

					case 14:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this, [[3, 11]]);
	}));

	return function loadResource() {
		return _ref2.apply(this, arguments);
	};
}();

var loadResourceAssigned = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
		var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
		var params, response;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						this.currentPageAssigned = page;
						this.params.page = this.currentPageAssigned;
						params = {
							isSelected: 1,
							page: this.params.page,
							perPage: 30,
							appId: this.appIdAssigned
						};
						_context3.prev = 3;
						_context3.next = 6;
						return this.$http.get('distributaries/' + this.id + '/resources', { params: params });

					case 6:
						response = _context3.sent;

						this.listResourceAssigned = response.data.data;
						this.lastPageAssigned = Number(response.headers['x-last-page']);
						_context3.next = 14;
						break;

					case 11:
						_context3.prev = 11;
						_context3.t0 = _context3['catch'](3);

						if (_context3.t0.status === 500) {
							this.showError();
						}

					case 14:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this, [[3, 11]]);
	}));

	return function loadResourceAssigned() {
		return _ref3.apply(this, arguments);
	};
}();

var assignedResource = function () {
	var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
		var resourcesIds;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
			while (1) {
				switch (_context4.prev = _context4.next) {
					case 0:
						resourcesIds = this.dataSelected.map(function (p) {
							return p.id;
						});
						_context4.prev = 1;
						_context4.next = 4;
						return this.$http.post('distributaries/' + this.id + '/resources', { resourcesIds: resourcesIds });

					case 4:
						this.closeModal();
						this.loadResource();
						this.showNotification('Los recursos fueron asignados correctamente.');
						_context4.next = 12;
						break;

					case 9:
						_context4.prev = 9;
						_context4.t0 = _context4['catch'](1);

						this.showError();

					case 12:
					case 'end':
						return _context4.stop();
				}
			}
		}, _callee4, this, [[1, 9]]);
	}));

	return function assignedResource() {
		return _ref4.apply(this, arguments);
	};
}();

var deallocateResource = function () {
	var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
		var ids, body;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
			while (1) {
				switch (_context5.prev = _context5.next) {
					case 0:
						ids = this.dataSelectedAssigned.map(function (p) {
							return p.id;
						});
						body = {
							page: this.params.page,
							resourcesIds: ids
						};
						_context5.prev = 2;
						_context5.next = 5;
						return this.$http.delete('distributaries/' + this.id + '/resources', { data: body });

					case 5:
						this.closeModal();
						this.loadResourceAssigned();
						this.showNotification('Los recursos fueron desasignados.');
						_context5.next = 13;
						break;

					case 10:
						_context5.prev = 10;
						_context5.t0 = _context5['catch'](2);

						this.showError();

					case 13:
					case 'end':
						return _context5.stop();
				}
			}
		}, _callee5, this, [[2, 10]]);
	}));

	return function deallocateResource() {
		return _ref5.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function created() {
	this.loadApplications();
	this.loadResource();
	this.loadResourceAssigned();
}

function rowIsSelected(row) {
	this.listResource = this.selectIsRow(this.listResource, this.selectedValue, row);
	this.dataSelected = this.listResource.filter(function (r) {
		return r.flag;
	});
	this.checkAll = this.every(this.listResource, this.selectedValue);
}

function rowIsSelectedDeallocated(row) {
	this.listResourceAssigned = this.selectIsRow(this.listResourceAssigned, this.selectedValueAssigned, row);
	this.dataSelectedAssigned = this.listResourceAssigned.filter(function (r) {
		return r.flagAssigned;
	});
	this.checkAllAssigned = this.every(this.listResourceAssigned, this.selectedValueAssigned);
}

function allSelected(checked) {
	var _this = this;

	this.checkAll = checked;
	this.dataSelected = [];
	this.listResource = this.listResource.map(function (element) {
		var newRow = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, element);
		newRow.isSelected = checked;
		if (checked) {
			_this.dataSelected.push(element);
		}
		return newRow;
	});
	this.listResource = this.selectIsRow(this.listResource, this.selectedValue, false, checked);
}

function allSelectedAssigned(checked) {
	var _this2 = this;

	this.checkAllAssigned = checked;
	this.dataSelectedAssigned = [];
	this.listResourceAssigned = this.listResourceAssigned.map(function (element) {
		var newRowAssigned = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, element);
		newRowAssigned.isSelected = checked;
		if (checked) {
			_this2.dataSelectedAssigned.push(element);
		}
		return newRowAssigned;
	});
	this.listResourceAssigned = this.selectIsRow(this.listResourceAssigned, this.selectedValue, false, checked);
}

function closeModal() {
	this.goTo('page-config-dealers');
}

function disabledAssigned(value) {
	return this.tabsResource === value || this.dataSelected.length < 1;
}

function disabledDeallocate(value) {
	return this.tabsResource === value || this.dataSelectedAssigned.length < 1;
}

function data() {
	return {
		appId: '',
		appIdAssigned: '',
		checkAll: false,
		checkAllAssigned: false,
		columns: [{ id: 1, name: 'URI', value: 'uri', checked: true, visible: true }, { id: 2, name: 'Descripción', value: 'description', checked: true, visible: true }, { id: 3, name: 'Módulo', value: 'module', checked: true, visible: true }],
		currentPage: 1,
		currentPageAssigned: 1,
		dataSelected: [],
		dataSelectedAssigned: [],
		lastPage: 0,
		lastPageAssigned: 0,
		listApplications: [],
		listApplicationsAssigned: [],
		listResource: [],
		listResourceAssigned: [],
		selectedValue: 'flag',
		selectedValueAssigned: 'flagAssigned',
		tabs: [{
			id: 1,
			name: 'Asignar'
		}, {
			id: 2,
			name: 'Asignados'
		}],
		tabsResource: null
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-dealers-resource',
	created: created,
	data: data,
	components: {
		actionSidebar: __WEBPACK_IMPORTED_MODULE_3__components_shared_action_sidebar__["default"]
	},
	methods: {
		allSelected: allSelected,
		allSelectedAssigned: allSelectedAssigned,
		assignedResource: assignedResource,
		closeModal: closeModal,
		deallocateResource: deallocateResource,
		disabledAssigned: disabledAssigned,
		disabledDeallocate: disabledDeallocate,
		loadApplications: loadApplications,
		loadResource: loadResource,
		loadResourceAssigned: loadResourceAssigned,
		rowIsSelected: rowIsSelected,
		rowIsSelectedDeallocated: rowIsSelectedDeallocated
	},
	props: {
		id: {
			type: [String, Number]
		}
	}
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/60.b9f75e6dfda552de5bbe.js